import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FLEX_STUDY_TAG } from '../../constants';

const DynamicTabs = ({ tabs, handleSelect, moduleStudy, styles, selectedIndex,
  activeScreen }) => {
  const renderTabs = () => {
    const tabTitles = [];

    const tabsBasedOnFlexMarket = tabs.filter(tab => {
      if (activeScreen !== 'functionBox') {
        if (moduleStudy && moduleStudy.st && !moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          return tab.title !== 'Geographies';
        }
      }
      // tabs to include publications in functions
      if (activeScreen === 'functionBox') {
        if (moduleStudy && moduleStudy.sd && moduleStudy.sd !== '2020 Spring MRI') {
          return tab.title !== 'Publications';
        }
      }
      return tab;
    });
    const tabContents = tabsBasedOnFlexMarket.map(tab => {
      tabTitles.push(<Tab className={`dynamic-tab_${tab.title}`} key={tab.title} style={styles} >{tab.title}</Tab>);
      return <TabPanel key={tab.title}>{tab.content}</TabPanel>;
    });

    return (
      <Tabs onSelect={handleSelect} selectedIndex={selectedIndex}>
        <TabList>{tabTitles}</TabList>
        {tabContents}
      </Tabs>
    );
  };

  return <div> {renderTabs()} </div>;
};

DynamicTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSelect: PropTypes.func,
  moduleStudy: PropTypes.shape({}),
};

DynamicTabs.defaultProps = {
  handleSelect: (index, last) => {
    if (window.localStorage.getItem('breadCrumb')) {
      window.localStorage.removeItem('breadCrumb');
    }
    console.warn(`Selected tab: ${index}, Last tab: ${last}`);
  },
};

export default DynamicTabs;
